<mat-form-field
  *ngIf="instances.length > 0"
  appearance="outline"
  class="tw-w-[160px] instance-selector"
  subscriptSizing="dynamic">
  <mat-select
    [value]="selectedInstance"
    (selectionChange)="onSelectionChange($event.value)"
    aria-label="Select LangGraph instance">
    <mat-option *ngFor="let inst of instances" [value]="inst.name">
      {{ inst.name }}
      <span *ngIf="inst.is_default" class="tw-text-xs tw-text-gray-400 tw-ml-1">(default)</span>
    </mat-option>
  </mat-select>
</mat-form-field>
